import { render, staticRenderFns } from "./AddBulkShipmentDrawer.vue?vue&type=template&id=ff88db42&"
import script from "./AddBulkShipmentDrawer.vue?vue&type=script&lang=ts&"
export * from "./AddBulkShipmentDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports